import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_doublerainbow: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-doublerainbow" {...rest}>
      <title>praise-doublerainbow</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#386CBB"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path
        fill="#FFF"
        d="M119.9 57.2c-.2-1.6-.6-3.2-1.4-4.7-4.7-9.6-19.3-12.1-32.6-5.6-19.8 9.6-67.9 42.7-54.7 69.8 4.7 9.6 19.3 12.1 32.5 5.7 7 6 19.2 6.8 30.5 1.3 11.6-5.7 18.5-16.3 17.7-25.6 2.3-.6 4.6-1.4 6.8-2.5C132 89.1 139 76 134.3 66.4c-2.4-5.3-7.9-8.4-14.4-9.2z"
      ></path>
      <path fill="#9AC3FF" d="M13 32.3c-2.9 4.3-5.4 8.9-7.4 13.7l56.1 56.1c5.8 5.8 15.3 5.8 21.1 0L13 32.3z"></path>
      <path fill="#84CA4B" d="M82.9 102.2l10.6-10.6-70.8-70.7c-3.6 3.5-6.8 7.3-9.6 11.5l69.8 69.8z"></path>
      <path fill="#FCD700" d="M22.7 20.9l70.7 70.7L104 81.1 34.4 11.5c-4.2 2.7-8.1 5.9-11.7 9.4z"></path>
      <path fill="#D1423B" d="M34.3 11.6l69.6 69.6c5.8-5.8 5.8-15.3 0-21.1L48.3 4.5c-5 1.9-9.6 4.3-14 7.1z"></path>
    </svg>
  );
};
